var page = ".onboarding";
var buttonNext = $(page + " .next");
var buttonPrev = $(page + " .previous");
var buttonSubmit = $(page + " .submit");
var containerActive = ".content.active";
var questionActive = ".question-step.active";
var questionStep = ".question-step";
var questionSearchdata = ".question-step.searchdata-question-step";

// Validaiton Checkbox, if one checked
function validateCheckbox() {
    var valid = false;
    if ($(page + ' ' + containerActive + ' input[type="checkbox"]').length > 0) {
        $(page + ' ' + containerActive + ' input[type="checkbox"]:checked').each(function() {
            valid = true;
        });
    } else {
        valid = true;
    }

    return valid;
}

function disabledButtonNext() {
    if ($(page + " " + containerActive).is(":last-child")) {
        disableButtonSubmit();
        return false;
    }
    var questionsCompleted = true;
    $(containerActive + " .question-step").each(function(){
        if ($(this).attr("data-complete") == "false") {
            questionsCompleted = false;
        }
    })
    if (questionsCompleted) {
        return false;
    }
    buttonNext.attr("disabled", true);
}

function enabledButtonNext() {
    if ($(page + " " + containerActive).is(":last-child")) {
        enabledButtonSubmit();
        return false;
    }
    var questionsCompleted = true;
    $(containerActive + " .question-step").each(function(){
        if ($(this).attr("data-complete") == "false") {
            questionsCompleted = false;
        }
    })
    if (!questionsCompleted) {
        return false;
    }
    buttonNext.attr("disabled", false);
}

function disableButtonSubmit() {
    if (!$(page + " " + containerActive).is(":last-child")) {
        disabledButtonNext();
        return false;
    }
    buttonSubmit.attr("disabled", true);
    buttonSubmit.addClass('btn-secondary').removeClass('btn-primary');
}

function enabledButtonSubmit() {
    if (!$(page + " " + containerActive).is(":last-child")) {
        enabledButtonNext();
        return false;
    }
    var questionsCompleted = true;
    $(".question-step").each(function(){
        if ($(this).attr("data-complete") == "false") {
            questionsCompleted = false;
        }
    })
    if (!questionsCompleted) {
        return false;
    }
    buttonSubmit.attr("disabled", false);
    buttonSubmit.addClass('btn-primary').removeClass('btn-secondary');
}

function showButtonNext() {
    buttonNext.show();
}

function hideButtonNext() {
    buttonNext.hide();
}

function showButtonPrev() {
    buttonPrev.show();
}

function hideButtonPrev() {
    buttonPrev.hide();
}

function showButtonSubmit() {
    buttonSubmit.show();
}

function hideButtonSubmit() {
    buttonSubmit.hide();
}

disableButtonSubmit();
disabledButtonNext();

// Onboarding list click
$(document).on("click", page + " " + containerActive + " " + questionActive + ' li', function() {
    var $this = $(this);
    var checkbox = $this.find(":checkbox");
    if (!checkbox.prop("checked")) {
        $this.addClass("active");
        checkbox.prop("checked", true);
        $(this).parent().closest(questionActive).attr('data-complete', 'true');
        showNextQuestion();
        enabledButtonNext();
    } else {
        $this.removeClass("active");
        checkbox.prop("checked", false);
        if ($(containerActive + " " + questionActive + " input:checked").length == 0) {
            $(this).parent().closest(questionActive).attr('data-complete', 'false');
            $(this).parent().closest(questionActive).find("#checkmark").removeClass("done");
        }
        disabledButtonNext();
    }
});

buttonNext.click(function() {
    var currentStep = $(page + " " + containerActive);
    var nextStep = currentStep.next();
    if (validateCheckbox()) {
        enabledButtonNext();
        nextStep.show();
        nextStep.addClass("active");
        currentStep.removeClass("active");
        currentStep.hide();
        showButtonPrev();
        disabledButtonNext();
        if (nextStep.is(':last-child')) {
            hideButtonNext();
            showButtonSubmit();
        }
    } else {
        disabledButtonNext();
    }
});

// Button Prev Click
buttonPrev.click(function() {
    var currentStep = $(page + " " + containerActive);
    var prevStep = currentStep.prev();
    prevStep.show();
    prevStep.addClass("active");
    currentStep.removeClass("active");
    currentStep.hide();
    showButtonNext();
    hideButtonSubmit();
    enabledButtonNext();
    if (prevStep.is(':first-child')) {
        hideButtonPrev();
    }
});

// Show Next Question
function showNextQuestion() {
    var containerQuestions = $(page + " " + containerActive + " .question-step");
    var possibleCurrent = $(page + " " + containerActive + " " + questionActive);
    var current;
    possibleCurrent.each(function(){
        if (checkIfFilled($(this))) {
            current = $(this);
        }
    })
    var next = current.next("[data-complete='false']");
    if (next.length == 0) {
        next = current.prev("[data-complete='false']");
    }
    if (current.length > 0 && containerQuestions.length > 1 && current.find("input").length == 1) {
        current.removeClass("active");
        current.addClass("disable");
    }
    if (next.length > 0) {
        next.addClass("active");
        next.removeClass("disable");
        next.find("#checkmark").removeClass("disable");
        next.find("h2").removeClass("disable");
        next.find('input[type="text"]').focus();
    }
    if (checkIfFilled(current)) {
        current.attr('data-complete', "true");
        current.find("#checkmark").addClass("done");
    }
}

// Event Click Question Button
$(document).on("click", page + " " + containerActive + " " + questionStep + " .question-button", function() {
    $(this).addClass('selected').siblings().removeClass('selected');
    var current = $(this).parent().closest(questionStep);
    var field = $(this).data('field');
    var value = $(this).data('value');
    $('input[name="' + field + '"]').val(value);
    showNextQuestion();
    enabledButtonSubmit();
    current.addClass("disable");
    current.removeClass("active");
    if (checkIfFilled(current)) {
        current.find("#checkmark").addClass("done");
    }
});

// Event Keyup input in question

var typingTimer;
var doneTypingInterval = 500;
$(document).on('blur', page + " " + containerActive + " " + questionActive + " input[type='text']", function() {
    if (!$(this).hasClass(questionSearchdata)) {
        if ($(this).val().length > 0) {
            showNextQuestion();
            enabledButtonSubmit();
        } else {
            var current = $(this).parent().closest(questionActive);
            current.attr('data-complete', "false");
            current.find("#checkmark").removeClass("done");
            disableButtonSubmit();
        }
    }
});

$(document).on('blur', page + " " + containerActive + " " + questionSearchdata + " input[type='text']", function() {
    var current = $(this).parent().closest(questionSearchdata);
    if ($(this).val().length > 0) {
        current.attr('data-complete', "true");
        current.find("#checkmark").addClass("done");
        enabledButtonSubmit();
    } else {
        current.attr('data-complete', "false");
        current.find("#checkmark").removeClass("done");
        disableButtonSubmit();
    }
});

// Event Click Question Header
$(".question-step-header").click(function() {
    var current = $(this).parent();

    if (current.attr('data-complete') == "true") {
        if (current.hasClass("disable")) {
            current.addClass("active");
            current.removeClass("disable");
            if (!checkIfFilled(current)) {
                current.find("#checkmark").removeClass("done");
            }
            current.find("h2").removeClass("disable");
        } else {
            current.addClass("disable");
            current.removeClass("active");
            if (checkIfFilled(current)) {
                current.find("#checkmark").addClass("done");
            }
        }

        current.find('input[type="text"]').focus();
    }
});

// Form Submit
$("form").submit(function() {
    if ($(this)[0].checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        disableButtonSubmit();
    } else {
        enabledButtonSubmit();
    }

    $(this).addClass('was-validated');
});

function checkIfFilled(question) {
    var inputVal = question.find("input");
    if (inputVal.length > 0 && inputVal.val().length == 0) {
        return false;
    }
    if (inputVal.length > 1) {
        var hasOptionChecked = false;
        inputVal.each(function() {
            if ($(this).is(":checked")) {
                hasOptionChecked = true;
            }
        })
        if (!hasOptionChecked) {
            return false;
        }
    }
    return true;
}